import api from '@/api'
import { filterMenuResources } from '@/utils/menuResources'
const state = {
  fileServer: {
    local: {
      url: '',
      isActive: false,
    },
    public: {
      url: '',
      isActive: false,
    },
    saas: {
      url: 'http://hhgw.kmdns.net:8003',
      isActive: true,
    },
  },
  systemName: '',
  systemLogo: '',
  userInfo: {},
  menuIsCollapse: false,
  addContactSuc: false, // 新建联系人
  addAnnualFeeSuc: false, // 新建年费
  addCustomerSuc: false, // 新建客户
  dictList: [], // 字典项
  menuList: [], // 菜单
  btnsPermission: {}, // 按钮权限
  isRefresh: false, // 往来收取
  omsMenu: [
    {
      id: 1,
      name: 'oms',
      path: '/oms',
      redirect: '/oms/dashboard',
      menuType: null,
      component: null,
      meta: {
        title: '租户管理',
        icon: '',
        type: 'menu',
        noCache: false,
        link: '/oms',
        titleHidden: true,
      },
      children: [
        {
          name: 'dashboard',
          path: '/oms/dashboard',
          redirect: '',
          menuType: null,
          component: 'oms/dashboard',
          meta: {
            title: '仪表盘',
            icon: 'hhgwself-dashboard hhgwself',
            type: 'menu',
            noCache: false,
            link: '/oms/dashboard',
            titleHidden: false,
          },
          children: null,
        },
        {
          name: 'selfRegistration',
          path: '/oms/selfRegistration',
          redirect: '',
          menuType: null,
          component: 'oms/selfRegistration',
          meta: {
            title: '自主注册',
            icon: 'hhgwself hhgwself-customer',
            type: 'menu',
            noCache: false,
            link: '/oms/selfRegistration',
            titleHidden: false,
          },
          children: null,
        },
        {
          name: 'manage_business',
          path: '/oms/business',
          redirect: '',
          menuType: null,
          component: null,
          meta: {
            title: '租户管理',
            icon: 'hhgwself-contacts hhgwself',
            type: 'menu',
            noCache: false,
            link: '/oms/business',
            titleHidden: false,
          },
          children: [
            {
              name: 'tenantManagement',
              path: '/oms/tenantManagement',
              redirect: '',
              menuType: null,
              component: 'oms/tenantManagement',
              meta: {
                title: '租户管理',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/tenantManagement',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'customerAuthManagement',
              path: '/oms/customerAuthManagement',
              redirect: '',
              menuType: null,
              component: 'oms/customerAuthManagement',
              meta: {
                title: '客户授权管理',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/customerAuthManagement',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'officialAccountLead',
              path: '/oms/officialAccountLead',
              redirect: '',
              menuType: null,
              component: 'oms/officialAccountLead',
              meta: {
                title: '服务号授权客户',
                icon: 'hhgwself-customer hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/officialAccountLead',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'tenantStatistics',
              path: '/oms/tenantStatistics',
              redirect: '',
              menuType: null,
              component: 'oms/tenantStatistics',
              meta: {
                title: '租户统计',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/tenantStatistics',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'userBehavior',
              path: '/oms/userBehavior',
              redirect: '',
              menuType: null,
              component: 'oms/userBehavior',
              meta: {
                title: '用户行为',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/userBehavior',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'moduleTrial',
              path: '/oms/moduleTrial',
              redirect: '',
              menuType: null,
              component: 'oms/moduleTrial',
              meta: {
                title: '模块试用',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/moduleTrial',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'dateManagement',
              path: '/oms/dateManagement',
              redirect: '',
              menuType: null,
              component: 'oms/dateManagement',
              meta: {
                title: '日期管理',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/dateManagement',
                titleHidden: false,
              },
              children: null,
            },
          ],
        },
        {
          name: 'operationManagement',
          path: '/oms/operationManagement',
          redirect: '',
          menuType: null,
          component: 'oms/operationManagement',
          meta: {
            title: '操作管理',
            icon: 'hhgwself hhgwself-customer',
            type: 'menu',
            noCache: false,
            link: '/oms/operationManagement',
            titleHidden: false,
          },
          children: null,
        },
        {
          name: 'versionUpdate',
          path: '/oms/versionUpdate',
          redirect: '',
          menuType: null,
          component: 'oms/versionUpdate',
          meta: {
            title: '版本更新',
            icon: 'hhgwself-systemconfig hhgwself',
            type: 'menu',
            noCache: false,
            link: '/oms/versionUpdate',
            titleHidden: false,
          },
          children: null,
        },
        {
          name: 'manage_aiManagement',
          path: '/oms/aiManagement',
          redirect: '',
          menuType: null,
          component: null,
          meta: {
            title: 'AI管理',
            icon: 'hhgwself-systemconfig hhgwself',
            type: 'menu',
            noCache: false,
            link: '/oms/aiManagement',
            titleHidden: false,
          },
          children: [
            {
              name: 'skillsManagement',
              path: '/oms/skillsManagement',
              redirect: '',
              menuType: null,
              component: 'oms/skillsManagement',
              meta: {
                title: '高企AI管理',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/skillsManagement',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'globalAIConfig',
              path: '/oms/globalAIConfig',
              redirect: '',
              menuType: null,
              component: 'oms/globalAIConfig',
              meta: {
                title: '全局AI配置',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/globalAIConfig',
                titleHidden: false,
              },
              children: null,
            },
            {
              name: 'globalWikiConfig',
              path: '/oms/globalWikiConfig',
              redirect: '',
              menuType: null,
              component: 'oms/globalWikiConfig',
              meta: {
                title: '高企WIKI配置',
                icon: 'hhgwself-systemconfig hhgwself',
                type: 'menu',
                noCache: false,
                link: '/oms/globalWikiConfig',
                titleHidden: false,
              },
              children: null,
            },
          ],
        },
      ],
    },
  ],
}

const getters = {
  fileServer: (state) => state.fileServer,
  systemName: (state) => state.systemName,
  systemLogo: (state) => state.systemLogo,
  userInfo: (state) => state.userInfo,
  menuIsCollapse: (state) => state.menuIsCollapse,
  addContactSuc: (state) => state.addContactSuc,
  addAnnualFeeSuc: (state) => state.addAnnualFeeSuc,
  addCustomerSuc: (state) => state.addCustomerSuc,
  dictList: (state) => state.dictList,
  getDictForCode: (state) => (code) => {
    return state.dictList.filter((item) => item.code === code)
  },
  menuList: (state) => state.menuList,
  btnsPermission: (state) => state.btnsPermission,
}

const mutations = {
  setFileServer(state, config) {
    state.fileServer.local.url = config.local
    state.fileServer.public.url = config.public
    state.fileServer.saas.url = config.saas

    checkFileServerListener(state.fileServer)
  },
  setSystemInfo(state, info) {
    if (info.logo) state.systemLogo = info.logo
    state.systemName = info.name
  },
  setUserInfo(state, user) {
    state.userInfo = user
  },
  setCommonObj(state, payload) {
    // 公用
    state[payload.key] = payload.value
  },
  toggleMenuIsCollapse(state) {
    state.menuIsCollapse = !state.menuIsCollapse
  },
  // 是否刷新收件箱
  REFRESH_EMAIL: (state, isRefresh) => {
    state.isRefresh = isRefresh
  },
}

const actions = {
  getFileServer({ commit }) {
    // api.common.querySysConfig.post().then(res => {
    api.system.getSystemBaseInfo.get().then((res) => {
      if (res.code === 200 && res.data) {
        if (res.data.logo) commit('setSystemInfo', res.data)
        // commit('setFileServer', res.data.fileServer)
      }
    })
  },
  getUserInfo({ commit }) {
    // api.common.queryLoginUser.post().then(res => {
    return api.omsAdmin.me.get().then((res) => {
      if (res.code === 200 && res.data) {
        commit('setUserInfo', res.data.user || res.data)
      }
    })
    // commit('setUserInfo', value)
  },
  getDictList({ commit }) {
    return api.common.getDictList.post().then((res) => {
      if (res.code === 200) {
        commit('setCommonObj', { key: 'dictList', value: res.data || [] })
      }
    })
  },
  getMenuList({ commit }) {
    return api.omsAdmin.menus.get().then(res => {
      if (res.code !== 200) throw new Error(res.message || '菜单加载失败')
      const data = res.data || {}
      const rawMenus = Array.isArray(data) ? data : (data.menus || [])
      const iconMap = {
        'oms.dashboard': 'hhgwself-dashboard hhgwself',
        'oms.selfRegistration': 'hhgwself hhgwself-customer',
        'oms.business': 'hhgwself-contacts hhgwself',
        'oms.tenantManagement': 'hhgwself-systemconfig hhgwself',
        'oms.customerAuthManagement': 'hhgwself-systemconfig hhgwself',
        'oms.officialAccountLead': 'hhgwself-customer hhgwself',
        'oms.tenantStatistics': 'hhgwself-systemconfig hhgwself',
        'oms.userBehavior': 'hhgwself-systemconfig hhgwself',
        'oms.moduleTrial': 'hhgwself-systemconfig hhgwself',
        'oms.dateManagement': 'hhgwself-systemconfig hhgwself',
        'oms.operationManagement': 'hhgwself hhgwself-customer',
        'oms.versionUpdate': 'hhgwself-systemconfig hhgwself',
        'oms.aiManagement': 'hhgwself-systemconfig hhgwself',
        'oms.skillsManagement': 'hhgwself-systemconfig hhgwself',
        'oms.globalAIConfig': 'hhgwself-systemconfig hhgwself',
        'oms.globalWikiConfig': 'hhgwself-systemconfig hhgwself'
      }
      const normalize = (item) => ({
        ...item,
        name: item.name || item.code,
        meta: { title: item.name, icon: item.icon || iconMap[item.code] || '', type: 'menu', code: item.code, link: item.path },
        children: (item.children || []).map(normalize)
      })
      const menus = filterMenuResources(rawMenus).map(normalize)
      commit('setCommonObj', { key: 'menuList', value: menus })
      commit('setCommonObj', { key: 'btnsPermission', value: Array.isArray(data.permissions) ? data.permissions : [] })
      return data
    })
  },
  /**
   * 刷新收件箱
   * @param {*} param
   */
  refreshEmail({ commit }) {
    return new Promise((resolve, reject) => {
      api.message.syncEmail
        .get()
        .then((res) => {
          if (res.success) {
            commit('REFRESH_EMAIL', { key: 'isRefresh', value: res.success })
            resolve()
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}
const checkFileServerListener = function (fileServer) {
  checkAllFileServer(fileServer)

  window.addEventListener('online', function () {
    // 网络由异常到正常时触发
    checkAllFileServer(fileServer)
  })
  window.addEventListener('offline', function () {
    // 网络由正常常到异常时触发
    checkAllFileServer(fileServer)
  })

  window.setInterval(() => {
    //每过5分钟检查文件服务的可用性 -- local
    checkFileServer(fileServer.local)
  }, 300000)

  window.setInterval(() => {
    //每过15分钟检查文件服务的可用性 -- public
    checkFileServer(fileServer.public)
  }, 900000)

  window.setInterval(() => {
    //每过30分钟检查文件服务的可用性 -- saas
    checkFileServer(fileServer.saas)
  }, 1800000)
}

const checkAllFileServer = function (fileServer) {
  checkFileServer(fileServer.local)
  checkFileServer(fileServer.public)
  checkFileServer(fileServer.saas)
}

const checkFileServer = async function (fileServerItem) {
  let serverUrl = fileServerItem.url
  if (serverUrl && serverUrl.length > 0) {
    const res = await api.common.fileServerHealthCheck.get(serverUrl)
    if (res.code === 200) {
      fileServerItem.isActive = true
    } else {
      fileServerItem.isActive = false
    }
  }
}

export default {
  state, // 变量
  actions, // 提交mutations,可做异步操作
  getters, // 对数据进行一些操作
  mutations, // 对状态做更改(同步)
}
